import SkeletonShippinGroupDetail from "components/Commons/Skeleton/SkeletonShippinGroupDetail"
import SummaryProductList from "components/Contractor/OrderDetail/SummaryProducts/SummaryProductsList"
import OrderDetailHOC from "hoc/OrderDetailHOC"
import { OrderDetailType } from "types/OrderType"
import ErrorHandler from "components/Commons/Error/ErrorHandler"
import { GlobalContext } from "context/context/GlobalContext"
import { useContext, useMemo } from "react"

const ContractorReceptionOtherScreen = ({ shippinGroupDetail, shippingGroupId, order }: OrderDetailType) => {
  const { errorHander } = useContext(GlobalContext)

  const itemsOrder = useMemo(() => {
    const sourceItems = shippinGroupDetail?.source?.items || []
    const orderItems = order?.items || []

    // Crear un mapa para búsqueda eficiente O(1)
    const supplierCodeMap = new Map<string, string>()

    orderItems.forEach((orderItem: any) => {
      if (orderItem?.sku && orderItem?.custom?.supplierCode) {
        supplierCodeMap.set(orderItem.sku, orderItem.custom.supplierCode)
      }
    })

    // Mapear sourceItems agregando el supplierCode donde haya coincidencia
    return sourceItems.map((item) => {
      const supplierCode = supplierCodeMap.get(item.sku)
      if (supplierCode) {
        return {
          ...item,
          supplierCode,
          custom: {
            ...item.custom,
            supplierCode
          }
        }
      }
      return item
    })
  }, [shippinGroupDetail?.source?.items, order?.items])

  return (
    <>
      {errorHander?.state?.hasError ? (
        <ErrorHandler
          code={errorHander.state.code}
          message={errorHander.state.message || "Ha ocurrido un error inesperado"}
        />
      ) : itemsOrder ? (
        <>
          <SummaryProductList
            itemsOrder={itemsOrder}
            groupPicking={false}
            titleMain={"Productos entregados"}
          />
        </>
      ) : (
        <SkeletonShippinGroupDetail />
      )}
    </>
  )
}

export default OrderDetailHOC(ContractorReceptionOtherScreen)
